import { render, staticRenderFns } from "./If65FileInput.vue?vue&type=template&id=201438d0"
import script from "./If65FileInput.vue?vue&type=script&lang=js"
export * from "./If65FileInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports